import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class CompaniesBasicRequest extends GenericRequest {

    term;
    onlyActive;

    constructor(term = '', onlyActive = false) {
        super(METHOD_POST, ApiEndpoints.COMPANIES_BASIC);

        this.term = term;
        this.onlyActive = onlyActive;
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        if ( this.term ) request.criteria.term = this.term;
        if ( this.onlyActive ) request.criteria.only_active = this.onlyActive;
        return request;
    }

}



// WEBPACK FOOTER //
// ./src/app/company/ws/CompaniesBasicRequest.js